import { isUndefined } from '../../predicates/type';
import { bodyOverlayPositionActiveClass } from '../../utils/renderProps/OverlayPosition';
import { SESSION_STORAGE_PREFIX } from './const';

function hasNextPageAnchorScroll(nextPathName: string) {
	const sessionStorageKeys = Object.keys(sessionStorage);
	const nextAnchorScrollPathName = `${SESSION_STORAGE_PREFIX}_${nextPathName}`;
	const item = sessionStorageKeys.find((i) => i.toLowerCase() === nextAnchorScrollPathName);

	return !isUndefined(item);
}

function getAnchorScrollPosition(pathName: string): null | number {
	const sessionStorageValue = window.sessionStorage.getItem(`${SESSION_STORAGE_PREFIX}_${pathName}`);

	if (sessionStorageValue === null) {
		return null;
	}

	const parsedPosition = Number(sessionStorageValue);

	return Number.isNaN(parsedPosition) ? null : parsedPosition;
}

function getActiveAnchorScrollPosition(): null | number {
	const pathName = window.location.pathname.toLowerCase();

	return getAnchorScrollPosition(pathName);
}

function tryPersistAnchorScrollPosition(pathName: string) {
	if (document.body.classList.contains(bodyOverlayPositionActiveClass)) {
		return;
	}

	window.sessionStorage.setItem(`${SESSION_STORAGE_PREFIX}_${pathName}`, String(window.scrollY));
}

function tryPersistActiveAnchorScrollPosition() {
	const pathName = window.location.pathname.toLowerCase();

	tryPersistAnchorScrollPosition(pathName);
}

function resetAnchorScrollPosition(pathName: string) {
	window.sessionStorage.removeItem(`${SESSION_STORAGE_PREFIX}_${pathName}`);
}

function resetActiveAnchorScrollPosition() {
	const pathName = window.location.pathname.toLowerCase();

	resetAnchorScrollPosition(pathName);
}

export {
	hasNextPageAnchorScroll,
	getActiveAnchorScrollPosition,
	getAnchorScrollPosition,
	tryPersistActiveAnchorScrollPosition,
	resetActiveAnchorScrollPosition,
	resetAnchorScrollPosition,
};
